<template>
  <div class="report-view task-time-sheet-report">
    <div v-if="exportLoader" class="report-loader-screen">
      <div class="d-flex align-items-center justify-content-center h-100 overdlow-sheet">
        <img src="../../../public/loader.gif" alt="">
      </div>
    </div>
    <div class="viewEdit ttrInfo">
      <b-card class="d-flex">
        <div class="calendar justify-content-between mt-0">
          <p class="task-timesheet">
            Clock Timesheet Report
          </p>
          <div id="date-select" class="d-flex justify-content-center align-items-center mr-0 calender">
            <VueDatePicker :start="startDate" :end="endDate" :active-btn="activeBtn" @date="updateDate" />
            <Help v-show="$store.state.app.userManualList" code="TR" />
          </div>
        </div>
      </b-card>
      <div class="card-filter-section mt-0">
        <b-row>
          <b-col cols="8" lg="8" class="d-block d-lg-flex align-items-center justify-content-start flex-wrap"> <button
              class="back-button btn btn-secondary mr-2" @click="back()">
              <feather-icon icon="ArrowLeftIcon" width="18" height="18" />
              <span>Back</span>
            </button>
            <p class="filter-title">
              Filters:
            </p>
            <div class="">
              <custom-dropdown v-model="is_active" :options="isActiveList" :search-box="false" :hide-close="true"
                label="Active" icon="EditIcon" />
            </div>
            <div>
              <custom-dropdown v-model="searchUser" :options="filterUserOptions" multiple label="Members"
                icon="EditIcon" />
            </div>
            <div v-if="userInfo && userInfo.role && userInfo.role == 'SA'" class="w-lg-100">
              <custom-dropdown v-model="manage_by" :options="manage_by_users" multiple label="Managed by"
                icon="EditIcon" />
            </div>
            <div>
              <custom-dropdown v-model="reporting_to" :options="reporting_to_users" multiple label="Reporting to"
                icon="EditIcon" />
            </div>
            <option-drop-down v-model="perPage" />
          </b-col>
          <b-col cols="4" lg="4" class="d-flex justify-content-end">
            <button class="apply-filter filterRedesign mr-1" @click="applyFilter()">
              Apply Filter
            </button>
            <button class="apply-filter-clear filterRedesign mr-1" @click="clearFilter()">
              Clear
            </button>
            <b-dropdown id="dropdown-right" right text="Export"
              class="custom-drop-timesheet-report filterRedesign side-bar-clear">
              <template #button-content>
                <div class="d-flex align-items-center">
                  <span class="mr-25 fw-600">Export</span>
                  <feather-icon icon="ChevronDownIcon" width="18" height="18" />
                </div>
              </template>
              <b-dropdown-item @click="confirmationFunction('PDF')">
                PDF
              </b-dropdown-item>
              <b-dropdown-item @click="confirmationFunction('CSV')"> XLSX
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </div>
      <div class="report-task-section">
        <list-loader v-if="loader && reports.length == 0" :fields="dynamicFields" />
        <div v-else-if="reports.length">
          <div class="emp-list time-sheet-list tableDesigns">
            <b-table :items="reports" :fields="dynamicFields" show-empty responsive
              class="emp-list-data emp-list-report table-responsive time-sheet-report">
              <template #head(action)>
                <div>
                  <button @click="showSidebar = !showSidebar" class="btn btn-sm d-flex"
                    style="padding-left: 0; padding-right: 0; padding-bottom: 5px;">
                    <feather-icon icon="ColumnsIcon" size="21" class="mr-0" />
                  </button>
                </div>
              </template>
              <template #cell(employee_name)="data">
                <div class="d-flex align-items-center new-time-report">
                  <b-avatar size="30" :src="data.item.picture"
                  :text="(data.item.employee_name || '').split(' ')[0] | avatarText" style="background-color: #f97753"  v-if="data.item.employee_name" />
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.employee_name ? data.item.employee_name : "" }}
                    </p>
                  </div>
                </div>
              </template>
              <template #cell(date)="data">
                <div class="d-flex align-items-center">
                  <p class="date">
                    {{ data.item.date | DateDDMMYYYYFormat }}
                  </p>
                </div>
              </template>
              <template #cell(first_clock_in)="data">
                <div>
                  <div v-if="data.item.first_clock_in" class="align-items-center date">
                    {{ data.item.first_clock_in | formatTimeHHMM }}
                  </div>
                </div>
              </template>
              <template #cell(last_clock_out)="data">
                <div>
                  <div v-if="data.item.last_clock_out" class="align-items-center date">
                    {{ data.item.last_clock_out | formatTimeHHMM }}
                  </div>
                </div>
              </template>
              <template #cell(total_span_time)="data">
                <div>
                  <div v-if="data.item.total_span_time" class="align-items-center date">
                    {{ data.item.total_span_time | formatTimeHHMM }}
                  </div>
                </div>
              </template>
              <template #cell(total_clock_in_time)="data">
                <div>
                  <div v-if="data.item.total_clock_in_time" class="align-items-center date">
                    {{ data.item.total_clock_in_time | formatTimeHHMM }}
                  </div>
                </div>
              </template>
              <template #cell(total_break_time)="data">
                <div>
                  <div v-if="data.item.total_break_time" class="align-items-center date">
                    {{ data.item.total_break_time | formatTimeHHMM }}
                  </div>
                </div>
              </template>
              <template #cell(managed_by)="data">
                <div class="d-flex align-items-center new-time-report">
                  <b-avatar size="30" :src="data.item.picture" :text="(data.item.managed_by || '').split(' ')[0] | avatarText"
                    style="background-color: #f97753"  v-if="data.item.managed_by"/>

                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.managed_by ? data.item.managed_by : "" }}
                    </p>
                  </div>
                </div>
              </template>
              <template #cell(reporting_to)="data">
                <div class="d-flex align-items-center new-time-report">
                  <b-avatar size="30" :src="data.item.picture" :text="(data.item.reporting_to || '').split(' ')[0] | avatarText"
                    style="background-color: #f97753" v-if="data.item.reporting_to" />

                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.reporting_to ? data.item.reporting_to : "" }}
                    </p>
                  </div>
                </div>
              </template>
            </b-table>
            <div>
              <div v-if="showSidebar" class="sidebar-overlay">
                <div class="overlay" @click.prevent="closeSidebar()" />
                <div class="sidebar-content">
                  <h5 class="mb-2 filter-title" style="padding-left: 19px;">Customize Columns</h5>
                  <div v-for="(visible, key) in filterColumns" :key="key" class="form-check form-switch mb-2">
                    <div class="d-flex align-items-center">
                      <b-form-checkbox v-model="filterColumns[key]" class="custom-control-success"
                        :id="`checkbox-${key}`" :name="`checkbox-${key}`" switch size="md" :inline="true">
                        <span class="switch-icon-left">
                          <feather-icon icon="CheckIcon" />
                        </span>
                        <span class="switch-icon-right">
                          <feather-icon icon="XIcon" />
                        </span>
                      </b-form-checkbox>
                      <span>{{ convertToLabel(key) }}</span>
                    </div>
                  </div>
                  <div class="mt-3 d-flex justify-content-between">
                    <button class="show-all" @click="showAllColumns">
                      Show All
                    </button>
                    <button class="btn-role" @click="saveColumnFilters">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Pagination v-if="totalCount > 0" :current-page="currentPage" :per-page="perPage" :total-count="totalCount"
              class="report-pagination" @currentPage="currentPage = $event" />
          </div>
        </div>
        <div v-else class="w-100">
          <img src="@/assets/images/nodatafound/nodata.svg" alt="no-data" class="no-data-img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClockTimeSheetReportMixin from '../../mixin/report/clockTimesheetReport/index';
import ListLoader from '@/components/loaders/table-loading.vue'
import customDropdown from '@/components/dropdown/customDropdown.vue'
import VueDatePicker from '../../views/TaskSummary/calender.vue'


export default {
  name: 'ClockTimeSheet',
  components: {
    ListLoader,
    customDropdown,
    VueDatePicker,
  },
  mixins: [ClockTimeSheetReportMixin],
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/component-css/approvals.css";
@import "../../assets/scss/component-css/report.css";
@import "../../assets/scss/variables/_variables.scss";
@import "../../assets/scss/component-css/clockTimesheetReport.scss";
</style>
